module.exports = __webpack_public_path__ + "img/camera.166a2ab0.png";